import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ conversationId }) =>
    present(
      repository
        .getChatConversationMessages(conversationId)
        .then((messages) => ({ conversationId, messages }))
        .catch((error) => Promise.reject({ conversationId, error })),
    );
}

export type { Interactor };

export { createInteractor };
